import { unescape } from 'lodash';

type MarkFunctionProperties<Component> = {
  [Key in keyof Component]: Component[Key] extends Function ? never : Key;
};
type ExcludeFunctionPropertyNames<T> = MarkFunctionProperties<T>[keyof T];
type ExcludeFunctions<T> = Pick<T, ExcludeFunctionPropertyNames<T>>;

export type NgChanges<Component, Props = ExcludeFunctions<Component>> = {
  [Key in keyof Props]: {
    previousValue: Props[Key];
    currentValue: Props[Key];
    firstChange: boolean;
    isFirstChange(): boolean;
  };
};

export const removeSearchParams = (url: string) => {
  const newUrl = url.replace(/[?#].*$/, '');

  return newUrl;
};

export const generateTemplatePreviewUrlUsingBase64 = (url: string, params: Record<string, string | boolean | number | (string | number)[] | null>): string => {
  try {
    const stringified = JSON.stringify(params);
    const base64 = btoa(unescape(encodeURIComponent(stringified)));

    const newUrl = (url.includes('?') ? url.substring(0, url.indexOf('?')) : url) + `?preview_mode=1&payload=${base64}`;

    return newUrl;
  } catch (err) {
    return url;
  }
};

export const copyToClipboard = async (
  text: string,
  config?: { successMessage?: string; errorMessage?: string }
): Promise<{ success: boolean; message: string }> => {
  try {
    await navigator.clipboard.writeText(text);

    if (config && config.successMessage) {
      return { success: true, message: config.successMessage };
    }

    return { success: true, message: 'view_translations.copied' };
  } catch {
    if (config && config.errorMessage) {
      return { success: false, message: config.errorMessage };
    }
    return { success: false, message: 'view_translations.copy_failed' };
  }
};
